import { InfoIcon } from '@assets/icons'
import { Spacer, Tooltip, Text, PropsText } from 'components'
import { JSX } from 'react'

interface Props {
  label?: string
  tooltipHeader: string
  tooltipDescription: string
  labelTextOptions?: PropsText
}

const InfoTooltip = ({
  label,
  tooltipHeader,
  tooltipDescription,
  labelTextOptions,
}: Props): JSX.Element => {
  return (
    <div className='d-flex align-center'>
      {label && (
        <>
          <Text preset='paragraph2' text={label} {...labelTextOptions} />
          <Spacer preset='tiny' />
        </>
      )}
      <Tooltip
        content={
          <>
            <Text preset='headline4' text={tooltipHeader} />
            <Spacer preset='tinyPlus' />
            <Text preset='paragraph2' text={tooltipDescription} />
          </>
        }
      >
        <InfoIcon color='tertiary' size={18} />
      </Tooltip>
    </div>
  )
}

export default InfoTooltip
